import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject, transient, computedFrom } from "aurelia-framework";
import { TabModel } from "@rightship-tech/common-ui/models/basic.models";
import { Permissions } from "./tabs/permissions/permissions";
import { EventAggregator } from "aurelia-event-aggregator";
import { DocumentManagementService } from "../../../services/document-management.service";

@autoinject
@transient()
export class DialogManageAccessShareOutcome {
    public tabs: TabModel[];
    private _currentTab: TabModel;
    private _rightshipInspectionId: number;
    public emails: string[] = [];
    public onSave: () => Promise<void>;
    public refreshEmails: (emails: string[]) => void;

    constructor(private dialogClientService: DialogClientService, private permissions: Permissions, private eventAggregator: EventAggregator,
        private documentManagementService: DocumentManagementService
    ) {
    }

    async activate(model: { rightshipInspectionId: number, emails: string[], onSave: () => Promise<void>, refreshEmails: (emails: string[]) => void; }) {
        this._rightshipInspectionId = model.rightshipInspectionId;
        await this.loadAccess();
        this.onSave = model.onSave;
        this.refreshEmails = model.refreshEmails;
    }

    async loadAccess() {
        const result = await this.documentManagementService.listRightshipInspectionDocumentAccess(this._rightshipInspectionId);
        this.emails = result.accesses[0].emails;
        this.eventAggregator.publish("emails-changed", { emails: this.emails });
        this.tabs = [
            {
                title: "Permissions",
                step: 1,
                show: true,
                vm: this.permissions,
                getModel: () => {
                    return {
                        emails: this.emails,
                        rightshipInspectionId: this._rightshipInspectionId,
                        loadAccess: this.loadAccess.bind(this),
                        refreshEmails: this.refreshEmails.bind(this)
                    }
                }
            }
        ];
    }

    async attached() {
        
    }

    tabChanged(event:any){
        this._currentTab = null;
        const step = event.detail.step;

        setTimeout(() => {
            const tab = this.tabs.filter(x=>x.step == step)[0];
            this._currentTab = tab
        });
    }

    @computedFrom("_currentTab")
    get currentTab(){
        return this._currentTab;
    }

    async close() {
        this.dialogClientService.hide();
        await this.onSave();
    }
}